import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Invoices = ({
  size,
  type,
  theme,
  className,
  dataTestId = "invoices-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.00004 1.33337C3.63185 1.33337 3.33337 1.63185 3.33337 2.00004V12.5C3.33337 12.9603 2.96028 13.3334 2.50004 13.3334C2.0398 13.3334 1.66671 12.9603 1.66671 12.5V6.50004C1.66671 6.13185 1.36823 5.83337 1.00004 5.83337C0.631851 5.83337 0.333374 6.13185 0.333374 6.50004V12.5C0.333374 13.6967 1.30342 14.6667 2.50004 14.6667H12.6667C13.7713 14.6667 14.6667 13.7713 14.6667 12.6667V2.00004C14.6667 1.63185 14.3682 1.33337 14 1.33337H4.00004ZM12.6667 13.3334H4.50065C4.60763 13.0768 4.66671 12.7953 4.66671 12.5V2.66671H13.3334V5.33337H8.00004C7.63185 5.33337 7.33337 5.63185 7.33337 6.00004C7.33337 6.36823 7.63185 6.66671 8.00004 6.66671H13.3334V12.6667C13.3334 13.0349 13.0349 13.3334 12.6667 13.3334Z"
    />
  </SVGIcon>
);
